/**
 * Paths that should never be the post-login landing destination.
 *
 * These routes are intentionally kept reachable in code so internal
 * redirects (e.g. TrialExpiredGate sending an expired clinic to
 * /packages-pricing) still work, but they are filtered out of the
 * top-level navigation. Users should never land on them after a fresh
 * login or token refresh.
 */
const NON_LANDING_PATHS: ReadonlyArray<string> = [
  '/packages-pricing',
  // Never bounce a just-logged-in user back to an auth page — guards
  // against a returnTo=/auth/login redirect loop.
  '/auth/',
];

/**
 * Sanitizes a candidate post-login redirect path.
 *
 * - Returns '/' for null / undefined / empty input.
 * - Returns '/' if the path matches a route on the non-landing list
 *   (e.g. '/packages-pricing', '/packages-pricing?from=...').
 * - Otherwise returns the path unchanged.
 */
const sanitizeReturnTo = (path: string | null | undefined): string => {
  if (!path) return '/';
  if (NON_LANDING_PATHS.some((p) => path.startsWith(p))) return '/';
  return path;
};

export default sanitizeReturnTo;
